<script>
import { serviceColors, statusColors, service, status } from "../../config/transaction"

export default {
  computed: {
    statusColors,
    serviceColors,
    tags() {
      return Object.fromEntries(new Map(Object.values(status).map((v) => [ v, 'total_' + v])))
    },
    paymentConversionRate() {
      if (this.loading)
        return 0
      if (this.statistic.total_inquiries === 0 || this.statistic.total_payments === 0)
        return 0
      return (this.statistic.total_payments / this.statistic.total_inquiries) * 100;
    },
    failureRate() {
      if (this.loading)
        return 0
      if (this.statistic.total_records === 0 || this.statistic.total_failed === 0)
        return 0

      return (this.statistic.total_failed / this.statistic.total_records) * 100;
    }
  },
  data: () => ({
    ...service,
    ...status,
    loading: false,
    statistic: {},
  }),
  methods: {
    sync(filters) {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.transaction.statistic'), {
        params: filters
      })
        .then((r) => this.statistic = r.data)
        .catch((e) => this.handleXhrError(e))
        .finally(() => this.loading = false)
    },
    ticked() {
      this.sync(this.$refs.transactionList.$props.filters)
      this.$refs.transactionList.getItems()
    }
  }
}
</script>
<template>
  <div>
    <a-page-header :ghost="false">
      <template #extra>
        <h-interval-button @clocked="ticked" />
      </template>
      <template #tags>
        <a-tag v-for="(tag, status) in tags" :key="`tag-${status}`" :color="statusColors[status]" :title="status.toUpperCase()">
          {{ status.charAt(0).toUpperCase() }}: {{ isEmpty(statistic) ? 0 : statistic[tag] }}
        </a-tag>
      </template>

      <a-row type="flex" justify="space-between">
        <a-statistic title="Total Record" :value="loading ? 0 : statistic.total_records">
          <template #prefix>
            <a-icon type="barcode" />
          </template>
        </a-statistic>
        <a-statistic title="Total Inquiry" :value="loading ? 0 : statistic.total_inquiries" :value-style="{ color: serviceColors[TRANSACTION_SERVICE_INQUIRY] }">
          <template #prefix>
            <a-icon type="tag" />
          </template>
        </a-statistic>
        <a-statistic title="Total Payment" :value="loading ? 0 : statistic.total_payments" :value-style="{ color: serviceColors[TRANSACTION_SERVICE_PAYMENT] }">
          <template #prefix><a-icon type="tags" /></template>
        </a-statistic>
        <a-statistic title="Total Bills" :value="loading ? 0 : statistic.total_bills" :value-style="{ color: serviceColors[TRANSACTION_SERVICE_PAYMENT] }">
          <template #prefix>
            <a-icon type="file-done" />
          </template>
        </a-statistic>
        <a-statistic title="Payment Conversion" :value="loading ? 0 : paymentConversionRate" :precision="2" :value-style="{ color: statusColors[TRANSACTION_STATUS_SUCCESS] }">
          <template #prefix><a-icon type="swap" /></template>
          <template #suffix><a-icon type="percentage" /></template>
        </a-statistic>
        <a-statistic title="Failures Rate" :value="loading ? 0 : failureRate" :precision="2" :value-style="{ color: statusColors[TRANSACTION_STATUS_FAILED] }">
          <template #prefix><a-icon type="dislike" /></template>
          <template #suffix><a-icon type="percentage" /></template>
        </a-statistic>
        <a-statistic title="Total Price" :value="loading ? 0 : statistic.total_price" :value-style="{ color: '#237804'}">
          <template #suffix>IDR</template>
        </a-statistic>
        <a-statistic title="Total Profit" :value="loading ? 0 : (statistic.total_price - statistic.total_biller_price)" :value-style="{ color: '#237804'}">
          <template #suffix>IDR</template>
        </a-statistic>
        <a-statistic title="Total Base Price" :value="loading ? 0 : statistic.total_biller_price" :value-style="{ color: '#237804'}">
          <template #suffix>IDR</template>
        </a-statistic>
      </a-row>
    </a-page-header>
    <h-transaction-list ref="transactionList" @filtered="sync" />
  </div>
</template>
